// ----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------------
export class LibAction {
    count(aggregratingName, service) {
        service.aggregation.increase(aggregratingName);
    }
}
